import './DetailRemark.less';
export { default as DetailRemark } from './DetailRemark.js';
export { default } from './DetailRemark.js';